module.exports = __webpack_public_path__ + "img/building95-6.eb590a2a.jpg";